const capitalize = (text = '') => {
  const str = String(text).toLowerCase();

  if (!str) return '';

  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = {
  capitalize
};
